<template>
  <event-list type="evento" />
</template>

<script>
import EventList from '@/components/EventList'

export default {
  name: 'Events',
  components: {
    EventList
  }
}
</script>
